import axios from 'axios'

const URL_API = 'https://potenciasperifericas.org.br/api/v1'
export default class RegisterFirstInformationApi {
    getConfig() {
        const token = localStorage.getItem('usuario') ? JSON.parse(localStorage.getItem('usuario')).token : ''
        return {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }
    }

    getInitiativeNature() {
        return axios.get(`${URL_API}/first-info/natureza-iniciativa`)
    }

    getLegalFormat() {
        return axios.get(`${URL_API}/first-info/formato-juridico`)
    }

    getInitiativeType() {
        return axios.get(`${URL_API}/first-info/tipo-iniciativa`)
    }

    getOrganizationType() {
        return axios.get(`${URL_API}/first-info/tipo-organizacao`)
    }

    getStates() {
        return axios.get(`${URL_API}/first-info/estados`)
    }

    getCities(uf) {
        return axios.get(`${URL_API}/first-info/cidades/${uf}`)
    }

    createFirst(data) {
        return axios.post(`${URL_API}/cadastro/usuario`, { ...data, code_access: process.env.APPLICATION_ACCESS })
    }

    updateFirst(data) {
        return axios.put(`${URL_API}/first-info/update`, data, this.getConfig())
    }

    listFirst() {
        return axios.get(`${URL_API}/first-info`, this.getConfig())
    }
}



// WEBPACK FOOTER //
// ./src/api/register-first-information/RegisterFirstInformationApi.js